import nunjucks from 'nunjucks';

const env = nunjucks.configure({ autoescape: false });

export const parseTemplate = (
  template: string,
  data: Record<string, unknown>,
): string => {
  return env.renderString(template, data);
};
